import { render, staticRenderFns } from "./WaveContentSyncStatusCell.vue?vue&type=template&id=064f8446"
import script from "./WaveContentSyncStatusCell.vue?vue&type=script&lang=js"
export * from "./WaveContentSyncStatusCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports